export class PayloadError extends Error {
  constructor(
    message: string,
    public payload: any,
    errorOptions?: ErrorOptions,
  ) {
    super(message)
    this.cause = errorOptions?.cause
  }
}
